import { userAccountReducer as account } from './account';
import { userAuraSettingsReducer as auraSettings, UserAuraSettings } from './aura';
import { userIntegrationsReducer as integrations, UserIntegrationsState } from './integrations';
import { userMetadataReducer as metadata } from './metadata';
import { userNotificationsReducer as notifications } from './notifications';
import { userStatsReducer as stats } from './stats';
import UserStats from '@repo/utils/models/UserStats';
import { UserMetadata, UserNotificationsState, UserSession } from '@repo/utils/types';

export interface AppUser {
  account: UserSession;
  auraSettings: UserAuraSettings;
  integrations: UserIntegrationsState;
  metadata: UserMetadata;
  notifications: UserNotificationsState;
  stats: UserStats;
}

export default {
  account,
  auraSettings,
  integrations,
  metadata,
  notifications,
  stats,
};
